
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary to-secondary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-primary-foreground">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full mb-6">
              <Icon name="Rocket" size={16} className="text-white mr-2" />
              <span className="text-sm font-medium">Get Started Today</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Transform Your Vision into Intelligence
            </h2>

            <p className="text-lg text-primary-foreground/90 mb-8 leading-relaxed">
              Join hundreds of organizations already leveraging AI-powered analytics to make data-driven decisions. See results in weeks, not months.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Button
                variant="secondary"
                size="lg"
                iconName="Play"
                iconPosition="left"
                className="bg-white text-primary hover:bg-white/90">

                Watch Live Demo
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Calendar"
                iconPosition="left"
                className="border-white text-white hover:bg-white/10">

                Schedule Consultation
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div>
                <div className="text-3xl font-bold mb-1">500+</div>
                <div className="text-sm text-primary-foreground/80">Active Deployments</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-1">99.8%</div>
                <div className="text-sm text-primary-foreground/80">System Uptime</div>
              </div>
              <div>
                <div className="text-3xl font-bold mb-1">24/7</div>
                <div className="text-sm text-primary-foreground/80">Expert Support</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-brand-lg">
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon name="Zap" size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-2">Quick Implementation</h3>
                    <p className="text-primary-foreground/80 text-sm">
                      Deploy in days with our proven implementation framework and dedicated support team
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon name="Shield" size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-2">Enterprise Security</h3>
                    <p className="text-primary-foreground/80 text-sm">
                      Bank-grade encryption and compliance with international data protection standards
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon name="TrendingUp" size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-2">Proven ROI</h3>
                    <p className="text-primary-foreground/80 text-sm">
                      Average 340% ROI within first year with measurable business impact
                    </p>
                  </div>
                </div>

                <div className="pt-6 border-t border-white/20">
                  <div className="flex items-center gap-3">
                    <div className="flex -space-x-2">
                      <Image
                        src="https://img.rocket.new/generatedImages/rocket_gen_img_15518b7bf-1763300002668.png"
                        alt="Professional woman with short brown hair in business attire"
                        className="w-10 h-10 rounded-full border-2 border-white object-cover" />

                      <Image
                        src="https://img.rocket.new/generatedImages/rocket_gen_img_16ec19a17-1763296357606.png"
                        alt="Asian man in his forties wearing glasses and dark suit"
                        className="w-10 h-10 rounded-full border-2 border-white object-cover" />

                      <Image
                        src="https://img.rocket.new/generatedImages/rocket_gen_img_19dc372df-1763294269106.png"
                        alt="Hispanic woman with long dark hair in professional attire"
                        className="w-10 h-10 rounded-full border-2 border-white object-cover" />

                    </div>
                    <div className="text-sm text-primary-foreground/90">
                      Join <span className="font-bold">500+ organizations</span> already using camlytix AI
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default CTASection;